<template>
  <div>
    <div class="wwi-step-form">
      <wwi-page-header
        :step="3"
        :title="$t('pages.domain.title')"
        :description="$t('pages.domain.description')"
        :error="formError('domain') ? $t('pages.domain.error') : ''"
      />
      <float-label>
        <input
          ref="domain"
          v-model="domain"
          :placeholder="$t('pages.domain.domain')"
          type="text"
          :class="{ 'wwi-form--error': formError('domain') }"
          @keyup.enter="submit()"
        >
      </float-label>
      <wwi-continue-back @continue="submit()" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      domain: ''
    }
  },
  mounted () {
    this.domain = this.$store.getters['userdata/userdata'].domain
    this.$refs.domain.focus()
  },
  methods: {
    async submit () {
      await this.$store.dispatch('userdata/ValidateDomain', this.domain)
      if (!this.formError('domain')) {
        this.$router.push('create_account')
      }
    }
  }
}
</script>
